import React from 'react';
import { InjectedRouter } from 'react-router';

import CoachingCoordinatorView from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorView';
import CoachingConstants from 'coaching/CoachingConstants';
import CurrentUser from 'auth/CurrentUser';
import CreateCoachingSessionContainer from 'coaching/containers/CreateCoachingSessionContainer';
import GetCoachesContainer from 'coaching/containers/GetCoachesContainer';
import GetParticipantsContainer from 'coaching/containers/GetParticipantsContainer';
import { CoachingUserType } from 'globalTypes';
import { GetParticipantList_coaching_getParticipantList_participants } from 'coaching/queries/__generated__/GetParticipantList';
import GetCancellationReasonsContainer from 'coaching/containers/GetCancellationReasonsContainer';

type Props = {
  router: InjectedRouter;
};

type State = {
  selectedParticipantUuid?: string;
};

export default class CoachingCoordinatorContainer extends React.Component<Props, State> {
  state: State = {
    selectedParticipantUuid: undefined,
  };

  selectParticipant = (
    participant: GetParticipantList_coaching_getParticipantList_participants
  ) => {
    this.setState({ selectedParticipantUuid: participant.uuid });
  };

  render() {
    const user = CurrentUser.isSignedIn() && CurrentUser.getUser();
    if (!user.hasFeature('coaching_coordinator.web.may-20')) {
      this.props.router.push(CoachingConstants.DEFAULT_SIGNED_IN_ROUTE);
      return null;
    }

    const { selectedParticipantUuid } = this.state;
    return (
      <CreateCoachingSessionContainer
        participantUuid={selectedParticipantUuid}
        userType={CoachingUserType.participant}>
        {({ createCoachingSession }) => {
          return (
            <GetCoachesContainer>
              {({
                loading: loadingCoaches,
                error,
                coaches,
                onNextPage: onNextCoachPage,
                endCursor: coachEndCursor,
                hasNextPage: coachListHasNextPage,
              }) => {
                const coachesErrorMessage = error?.message;
                return (
                  <GetParticipantsContainer>
                    {({
                      loading: loadingParticipants,
                      error,
                      participants,
                      onNextPage: onNextParticipantPage,
                      endCursor: participantEndCursor,
                      hasNextPage: participantListHasNextPage,
                    }) => {
                      const participantsErrorMessage = error?.message;
                      return (
                        <GetCancellationReasonsContainer>
                          {({ cancellationReasons, loading: loadingCancellationReasons, error }) => {
                            const getCancellationReasonsErrorMessage = error?.message;
                            return (
                              <CoachingCoordinatorView
                                loadingParticipants={loadingParticipants}
                                loadingCoaches={loadingCoaches}
                                loadingCancellationReasons={loadingCancellationReasons}
                                participantsError={participantsErrorMessage}
                                coachesError={coachesErrorMessage}
                                cancellationReasonsError={getCancellationReasonsErrorMessage}
                                cancellationReasons={cancellationReasons}
                                participants={participants}
                                coaches={coaches}
                                onSelectParticipant={this.selectParticipant}
                                selectedParticipant={participants?.find(
                                  p => p.uuid === selectedParticipantUuid
                                )}
                                participantPagination={{
                                  onNextPage: () => onNextParticipantPage(participantEndCursor),
                                  hasNextPage: participantListHasNextPage,
                                }}
                                coachPagination={{
                                  onNextPage: () => onNextCoachPage(coachEndCursor),
                                  hasNextPage: coachListHasNextPage,
                                }}
                                onCreateCoachingSession={createCoachingSession}
                              />
                            );
                          }}
                        </GetCancellationReasonsContainer>
                      );
                    }}
                  </GetParticipantsContainer>
                );
              }}
            </GetCoachesContainer>
          );
        }}
      </CreateCoachingSessionContainer>
    );
  }
}
